import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { sportsHelpers } from "projectSpecific/sports/cnr/reducers/reducerHelpers/sportsHelpers";
import { _sportsOriginTypes } from "projectSpecific/sports/cnr/reducers/SportsReducer";
import { useCallback, useContext, useState } from "react";
import { DatabaseContext } from "../../../global/cnr/contexts/DatabaseContext";
import { _showAppLogs } from "../../../global/cnr/contexts/LogContext";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";
import { useCacheDataManager } from "../../../global/cnr/contexts/useHelpers/cacheDataManager";
import { useMultiDoc } from "../../../global/cnr/contexts/useHelpers/useMultiDoc";
import { AppTimestampContext } from "global/cnr/contexts/AppTimestampContext";
import { seasonalHelpers } from "../cnr/reducers/reducerHelpers/seasonalHelpers";
import { shouldUseCache } from "global/cnr/contexts/useHelpers/useHelpers";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { TimestampsContext } from "../../../global/cnr/contexts/TimestampsContext";

export const _sportSponsorTypes = {
  community: "community",
  schedule: 'schedule',
  scoreboard: "scoreboard",
  season: "season",
  standings: "standings",
  tournament: "tournament",
}

export const useSportsSponsor = () => {

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { sports: sportsKey } = pathViews ?? {}

  // appTimestampContext
  const appTimestampContext = useContext(AppTimestampContext);
  const { appTimestamp_state } = appTimestampContext ?? {}
  const { timestampInfo } = appTimestamp_state ?? {}
  const { timestamps } = timestampInfo ?? {}

  // timestampsContext
  const timestampsContext = useContext(TimestampsContext)
  const { timestamps_state } = timestampsContext ?? {}
  const { _validatedTimestamps } = timestamps_state ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const _pks = seasonalHelpers.getPks(pathViews)
  console.log('_pks', _pks)

  const [updating, setUpdating] = useState()

  const getSponsorshipTypes = useCallback(({ callback }) => {
    const cb = (sponsorshipTypes) => callback(sponsorshipTypes)
    const _refPath = createRefPath_event(pathViews, ['sponsorshipTypes'])
    database_fns.get_data({ refPath: _refPath, callback: cb })
  }, []);

  const getSponsors = useCallback(({ callback }) => {
    const cb = (sponsors) => callback(sponsors)
    const _refPath = createRefPath_event(pathViews, ['sponsors'])
    database_fns.get_data({ refPath: _refPath, callback: cb })
  }, []);

  const updateSponsorshipType = useCallback(({ sponsorship }) => {
    const cb = () => setUpdating(false)
    setUpdating(true)
    if (sponsorship?._itemKey) {
      const refPath = createRefPath_event(pathViews, ["sponsorshipTypes", sponsorship?._itemKey]);
      database_fns.update_doc(refPath, sponsorship, cb)
    } else {
      const refPath = createRefPath_event(pathViews, ["sponsorshipTypes"]);
      database_fns.add_doc(refPath, sponsorship, cb)
    }
  }, []);

  const updateSponsor = useCallback(({ sponsor }) => {
    _.forEach(_pks, (value, key) => {
      _.set(sponsor, key, [...(_.get(sponsor, key, [])), value])
    })
    const cb = () => setUpdating(false)
    setUpdating(true)
    const refPath = createRefPath_event(pathViews, ["sponsors", sponsor?._itemKey]);
    database_fns.update_doc(refPath, sponsor, cb)
  }, []);

  const createSponsor = useCallback(({ sponsor }) => {
    _.forEach(_pks, (value, key) => {
      _.set(sponsor, key, [...(_.get(sponsor, key, [])), value])
    })
    const cb = () => setUpdating(false)
    setUpdating(true)
    const refPath = createRefPath_event(pathViews, ["sponsors"]);
    database_fns.add_doc(refPath, sponsor, cb)
  }, []);

  return { getSponsorshipTypes, getSponsors, updateSponsorshipType, updateSponsor, createSponsor, updating }

}
